import { render } from "./ActionPanel.vue?vue&type=template&id=5c2f52f4&scoped=true"
import script from "./ActionPanel.vue?vue&type=script&lang=js"
export * from "./ActionPanel.vue?vue&type=script&lang=js"

import "./ActionPanel.vue?vue&type=style&index=0&id=5c2f52f4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2f52f4"]])

export default __exports__